import btnZoomIn from "../../../../images/contents/map/livecamera/bt_zoomIn.png";
import btnZoomOut from "../../../../images/contents/map/livecamera/bt_zoomOut.png";
import btnClose from "../../../../images/contents/map/livecamera/btn_close.png";
import brokenImg from "../../../../images/contents/map/livecamera/broken_img.png";
import { isJa, translation } from "../../../../utils/FPEUtils";

const cameraIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFUSURBVHgB7ZSvT8NAHMW/t/4YhqSoIZtgGDSwOUB1BgGClllCJkkwgwQ8GrFgQC5hnhQJgvIftCybg7SYLVNUjx7HXcIc7a5JEcB9XNvvu/f6Td4BCAQCwX8HJX0gHtFjBbcBIRM4IQAhEGyrhurzahIDvPex5167lYeOC7zU9mtg7pm3RUO22PO4GzeQBDvUxleWpbPvNIWU8zKZM7w7jy4MrTLjuP8RhL3X9s25Y9HNNJI0MuRINIrYSvWAGrs0fPAUgFbSUjW5BmBcHlzB8GXIPV+AnMli/iMBsvL3Auye2LBur3HP5x6gvFGGrcNt57hzBNXNytT5tBZEtEIaqxYvc7RyxdmZUFkq2HE3tuqn9dbgeaDTaiYekngTjnu4GY3eWt49961K/34R5hdKF6qhNCfvWBAJS4+oiqJMASZijMj0PX4hEeTLK7IDAoFA8Jv4BNs3bP7BKovcAAAAAElFTkSuQmCC";
const cameraIconNoDir = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAABWtJREFUWEftlmtQVVUUx/9rn3MuF0bEEQPSHBXfXB4+yHFGBUHjQ01aoej4TnPyUWqNj3REzDTLqawm08m0JktQUcwJZ1IRSUFE0Hjcq4151XyTrxJwuOecverchPA19+oXv7g/nr32Wr+1zn/ttQmPedFjjo8nAE8qcEcFuJQ1aUc6TB5JgtqDoD2ESFka8hJpIk/U423qRX/6c7YRgJmFp1Q/VHOjNqp0++GgSycvw/AY/vj4z4YIrdqGImpg1K0Oce09iipiKIbONjjgSo6VwDQQqpVoWtTw/X8AJ8+vuVa7+KPUT2ymbiKiUwQCg+1+A0jJOOc6B+vskLkv6j1S4optvbUEdnFnKbGYgFF/Vf9dr2gKBQbZd2q91Ze93A0R6ss8FYWZRTH56/dhZuabt1q2aRnod/TbhqZu6uve+EYzdQNT108BGLkMfv7q2WuevV/vDXDucyE62YFhGamsxAhxB4BZLuu2vZ8TeOPSDUxaNREk0ZFiye0vBDvZZuiyuCSnpOfuNXuwKG8hLp645Mlfl287XvgbWkS0gKopCO8YjhHvpUFEkzf5xgrIKuZN6Zu98ZoaNP5DFydIiUHEiGeBa4JRDMJacpCnwcZ0clZVXtWILRnZiIyPhLvUjbAOYUgcmyCjBznE5owt9/i/B4CIkLZkeCOhdYKdPIwZ3tOX3dUyJKw57M3swtDNM5qi9KRYum7tmZW8yZnvTLMCte/RDgnjErjTsx3J1GWFoolYK8G7/fusAP/KbaTgkxV7KgN+/mIXaq7XeLPoPqAbUtNfkaSIrQG9tDQvQJMKLNm/2OqiAk1V51MsHXxQhX0CGBXmV+dd5yesnbpOS5megj5D4+X54xcoa+Em6t6/G4bOG2IIphYUR7V3AxBhODko24J7ZAB2coY0ON199BR3jI9UCUg3TTmrMKsotGjTQczbMccS7ECKpYK7AZiwRgBzyEE1jw5wiu2yDh8Q0IOAbEgckZK3H8gqfMpqWUvtJPACRdHOpgBJE5PQf3Q/KYjqhErLicSy+4ncLxF6hcgs6sv0E1qAGnnWda5+47zMgLZRz2D0ilHWJdiZHPR7UxHam9khFGEJEX1eimfVppIvEcrNi7aQNCVGLhsBckAhItnYhk7uz4z9K0d8husXrqNdXDuM+XCUrgXaflFjxWDLzqiU2VV7qlK3Lc3Bwt0LuHjrISrcWAQShMRxCXCXub1Q970H6ss8f+xavbutc68Lc3fMhmmYhxVNqWPAJQhfgtHNasVFAxYjeVISBk5IhJT8o6LQcgmMZ8kOSO6Tu3Kn/WSZG7MyZ3jZTUPKkpwSceCHQty8ehOOgVEPACj1fHu6/MzYDbO/F9FJDsQMjkFgczue7tpaqopSqGrK60xw/fRxLhLHJ3iatQpeoURTuueoXmjqZt/zxy6IU2VuFG8tQfyQ3kh+LfmCjdQeUsNbkDwDhKBD20ooJCwEXfp2vqj1UlvfcRPyMQ6tr/GcOrilODh/3T7IfyeItaxsB4zuX631VMONSnMVTIxm8BHVprxKUXRGP2JcKfiuILRgw36EtglFt35dMGjyIEMNUJLIQQe8+jnOwdAxxTDNBUIImyBKoxjKvQPAa1jOHWpr6nKCQoLimswAZpbvimNiqdlVfi4NOZaBgza7Ot0Snl5hLlGESG+wt94EiibGkIPy/Jkj932ScSWHgxEJQgBsqKKudMWa56Ypj+R+ulNJHJ+gB4c1X604aObtqzoChC4wcA4xON1UvL4g/H4TspP7MOOQNWhSpj3naR4eslKJpnd8BfC17zeAt83KZbZQKNWoN/ZoQepk6k6nfQXwtf9QAL6cPcr+E4AnFXjsFfgHd0vGP0Y139EAAAAASUVORK5CYII=";

export const configLiveCameraDh = {
  "Controller": {
    "Name": "LiveCameraExt",
    "update_interval": 60,
    "request_timeout": 60,
    "download_max": 16,
    "min_request_interval": 2,
    "image_data_limit": 256000000,
    "max_window": 100,
    "animation_time_range": 1800,
    "image_time_range": 2592000,
    "name_type": isJa()? "LNAME":"ENAME",
    "style": "sky"
  },
  "Source": {
    "CameraMaster": {
      "Type": "JSON",
      "url": "%livecamera_api_url%/owner/selectable_list?contract_id=%contract_id%",
      "cache_busting": true
    },
    "ImageFileList": {
      "Type": "JSON",
      "url": "%baseUrl%/%camerapath%/%id%/search?begin_time=%time_start%&end_time=%time_end%",
      "alias": {
        "baseUrl": {
          "public": process.env.REACT_APP_EXPO_LIVECAMERA_URL,
          "SKY": process.env.REACT_APP_AWS_LIVECAMERA_URL,
          "external": process.env.REACT_APP_AWS_LIVECAMERA_URL,
          "internal": process.env.REACT_APP_AWS_LIVECAMERA_URL,
          "LAND": process.env.REACT_APP_AWS_LIVECAMERA_URL
        }
      },
      "download_max": 32,
      "cache_busting": true
    },
    "ImageFile": {
      "Type": "Image",
      "download_max": 32,
      "url": "%baseUrl%/%camerapath%/%id%/get/%time%.jpeg",
      "alias": {
        "baseUrl": {
          "public": process.env.REACT_APP_EXPO_LIVECAMERA_URL,
          "SKY": process.env.REACT_APP_AWS_LIVECAMERA_URL,
          "external": process.env.REACT_APP_AWS_LIVECAMERA_URL,
          "internal": process.env.REACT_APP_AWS_LIVECAMERA_URL,
          "LAND": process.env.REACT_APP_AWS_LIVECAMERA_URL
        }
      }
    },
    "_Thumbnail": {
      "Type": "Binary",
      "url": "%baseUrl%/%camerapath%/%id%/thumbnail?size=192x144",
      "download_max": 32,
      "cache_busting": true
    },
    "LatestImageFile": {
      "Type": "Text",
      "url": "%baseUrl%/%camerapath%/%id%/latestfile",
      "alias": {
        "baseUrl": {
          "public": process.env.REACT_APP_EXPO_LIVECAMERA_URL,
          "SKY": process.env.REACT_APP_AWS_LIVECAMERA_URL,
          "external": process.env.REACT_APP_AWS_LIVECAMERA_URL,
          "internal": process.env.REACT_APP_AWS_LIVECAMERA_URL,
          "LAND": process.env.REACT_APP_AWS_LIVECAMERA_URL
        }
      },
      "cache_busting": true
    },
    "data": {
      "Type": "Derived",
      "retain": true
    }
  }
}

export const configLiveCameraLayer = {
  "Name": "LiveCamera",
  "Renderer": "LiveCameraExt",
  "Attributes": {
    "date_format": "%month%/%day% %0hour%:%0min% UTC",
    "timezone": {
      "utc": {
        "date_format": "%month%/%day% %0hour%:%0min% UTC",
      },
      "Asia/Tokyo": {
        "date_format": "%local_month%/%local_day% %0local_hour%:%0local_min% JST",
      },
    },
    "expire": {
      "threshold": 600,
      "text": translation("Not updated for over 10 min"),
      "style": {
        "color": "#FF0000"
      }
    },
    "unavailable_message": translation("No image"),
    "initial_icon_fadein": 0.0,
    "initial_icon_fadeout": 2.0,
    "icon_fadein": 0.5,
    "icon_fadeout": 0.75,
    "zoom_in_button": btnZoomIn,
    "zoom_out_button": btnZoomOut,
    "close_button": btnClose,
    "error_image": brokenImg,
    "mini_icon_zoom": 6,
    "style": {
      "default": {
        "icon_overlap_margin": 8,
        "icon": cameraIcon,
        "unavailable_icon": cameraIcon,
        "icon_width": 32,
        "icon_height": 32,
        "icon_offset_x": -16,
        "icon_offset_y": -16,
        "icon_nondir": cameraIconNoDir,
        "icon_nondir_width": 24,
        "icon_nondir_height": 24,
        "icon_nondir_offset_x": -12,
        "icon_nondir_offset_y": -12,
        "mini_icon_overlap_margin": 4,
        "_mini_icon_overlap_margin": 0,
        "mini_icon": cameraIcon,
        "mini_unavailable_icon": cameraIcon,
        "mini_icon_width": 24,
        "mini_icon_height": 24,
        "mini_icon_offset_x": -12,
        "mini_icon_offset_y": -12,
        "mini_icon_nondir": cameraIconNoDir,
        "mini_icon_nondir_width": 16,
        "mini_icon_nondir_height": 16,
        "mini_icon_nondir_offset_x": -8,
        "mini_icon_nondir_offset_y": -8
      },
      "internal": {
        "icon": cameraIcon,
        "unavailable_icon": cameraIcon,
        "mini_icon": cameraIcon,
        "mini_unavailable_icon": cameraIcon
      },
      "external": {
        "icon": cameraIcon,
        "unavailable_icon": cameraIcon,
        "mini_icon": cameraIcon,
        "mini_unavailable_icon": cameraIcon
      },
      "land": {
        "icon": cameraIcon,
        "unavailable_icon": cameraIcon,
        "mini_icon": cameraIcon,
        "mini_unavailable_icon": cameraIcon
      },
      "sky": {
        "icon": cameraIcon,
        "unavailable_icon": cameraIcon,
        "mini_icon": cameraIcon,
        "mini_unavailable_icon": cameraIcon
      },
      "nextgen": {
        "icon_width" : 32,
        "icon_height" : 32,
        "icon_offset_x" : -16,
        "icon_offset_y" : -16,
        "icon_nondir" : cameraIconNoDir,
        "icon_t" : cameraIcon,
        "icon_s" : cameraIcon,
        "icon_a" : cameraIcon
      }
    }
  }
};